import {SET_SIGNUP_DATA, CLEAR_SIGNUP_DATA, SET_SHARES_DATA,
    SET_DELIVERY_DAY_FILTER, SELECT_PAYMENT_PLAN, SET_COUPON, REMOVE_COUPON,
    GOTO_STEP, CONTACT_INFO_STEP, SET_CONTACT_DETAILS, SET_MAP_PROPS, INIT_MAP_PROPS,
    JOIN_CHANGE_ITEM_QUANTITY, JOIN_SET_ITEM_SCHEDULE, SET_COUPON_STATUS,
    CLEAR_SHARES_SELECTION, SET_SELECTED_METHOD, SET_SIGNUP_COMMENTS, SET_HOME_DELIVERY_INSTRUCTIONS, SET_INVALID_OPTION_SCHEDULE_MESSAGE,
    SET_TERMS_SELECTED} from "../../actions/actionTypes";

export function joinReducer(state, action) {
    state = (state || {});
    switch (action.type) {
        case SET_SIGNUP_DATA:
            return Object.assign({}, state, {
                data: state.data ? state.data : action.signupData.data,
                steps: state.steps ? state.steps : action.signupData.steps,
                pickupSitesData: state.pickupSitesData ? state.pickupSitesData : action.signupData.pickupSitesData,
                paymentMethods: state.paymentMethods ? state.paymentMethods : action.signupData.paymentMethods,
                paymentPlans: state.paymentPlans ? state.paymentPlans : action.signupData.paymentPlans,
                schedules: state.schedules ? state.schedules : action.signupData.schedules,
                shareSchedules: state.shareSchedules ? state.shareSchedules : action.signupData.shareSchedules,
                isGuestUser: state.isGuestUser ? state.isGuestUser : action.signupData.isGuestUser,
                isAddSubscription: state.isAddSubscription ? state.isAddSubscription : action.signupData.isAddSubscription,
                sharesData: state.sharesData ? state.data : {},
            });
        case CLEAR_SIGNUP_DATA:
            return {};
        case SET_SHARES_DATA:
            let sharesData = {
                shares: action.sharesData.shares,
                options: action.sharesData.options,
                items: action.sharesData.items,
                remainingScheduleDates: action.sharesData.remainingScheduleDates,
                pickupSiteKey: action.key
            };
            return Object.assign({}, state, {
                sharesData: sharesData
            });
        case SET_DELIVERY_DAY_FILTER:
            let pickupSiteData = Object.assign({}, state.pickupSitesData, {});
            pickupSiteData["deliveryDayFilter"] =  action.deliveryDay;
            return Object.assign({}, state, {
                pickupSitesData: pickupSiteData
            });
        case SELECT_PAYMENT_PLAN: {
            const selectedData = (state.selectedData || {});
            let selectedPaymentPlan = state.paymentPlans.find(plan => {
                return plan.key === action.key;
            });
            return Object.assign({}, state, {
                selectedData: Object.assign({}, selectedData, {selectedPaymentPlan: selectedPaymentPlan})
            });
        }
        case SET_COUPON: {
            const selectedData = (state.selectedData || {});
            return Object.assign({}, state, {
                selectedData: Object.assign({}, selectedData, {coupon: action.coupon})
            });
        }
        case SET_COUPON_STATUS: {
            const selectedData = (state.selectedData || {});
            const coupon = selectedData.coupon;
            if(coupon) {
                coupon.status = action.status;
                return Object.assign({}, state, {
                    selectedData: Object.assign({}, selectedData, {coupon: coupon})
                });
            }
            return;
        }
        case REMOVE_COUPON: {
            const selectedData = (state.selectedData || {});
            return Object.assign({}, state, {
                selectedData: Object.assign({}, selectedData, {coupon: undefined})
            });
        }
        case GOTO_STEP:
            return Object.assign({}, state, {
                step: action.step
            });
        case  CONTACT_INFO_STEP:
            return Object.assign({}, state, {
                contactInfoPage: action.contactInfoPage
            });
        case SET_CONTACT_DETAILS:
            return Object.assign({}, state, {
                contactDetails: action.contactDetails
            });
        case JOIN_CHANGE_ITEM_QUANTITY: {
            let newState = Object.assign({}, state, {sharesData: Object.assign({}, state.sharesData)});
            const item = newState.sharesData.shares[action.key] || newState.sharesData.options[action.key];
            const schedule = item.selectedSchedule ? item.selectedSchedule : item.schedules && item.schedules.length > 0 ? item.schedules[0] : undefined;
            const newItemProps = {
                quantity: action.newQuantity,
                selectedSchedule: action.newQuantity > 0 ? schedule : undefined
            };
            let newItem = Object.assign({}, item, newItemProps);
            if (!item.isAdditional) {
                let newShares = Object.assign({}, newState.sharesData.shares);
                newShares[action.key] = newItem;
                newState.sharesData.shares = newShares;
            } else {
                let newOptions = Object.assign({}, newState.sharesData.options);
                newOptions[action.key] = newItem;
                newState.sharesData.options = newOptions;
            }
            return newState;
        }
        case JOIN_SET_ITEM_SCHEDULE: {
            let newState = Object.assign({}, state, {sharesData: Object.assign({}, state.sharesData)});
            const newItemProps = {selectedSchedule: action.selectedSchedule};
            let item = newState.sharesData.shares[action.key];
            let newItem;
            if (item) {
                let newShares = Object.assign({}, newState.sharesData.shares);
                newItem = Object.assign({}, item, newItemProps);
                newShares[action.key] = newItem;
                newState.sharesData.shares = newShares;
            } else {
                item = newState.sharesData.options[action.key];
                newItem = Object.assign({}, item, newItemProps);
                let newOptions = Object.assign({}, newState.sharesData.options);
                newOptions[action.key] = newItem;
                newState.sharesData.options = newOptions;
            }
            return newState;
        }
        case CLEAR_SHARES_SELECTION:
            if (!state.sharesData || !state.sharesData.shares)
                return state;
            const newState = Object.assign({}, state);
            if (state.selectedData) {
                newState.selectedData = {};
            }
            let newShares = {};
            Object.keys(state.sharesData.shares).map((key) => {
                let newShare =  Object.assign({}, state.sharesData.shares[key]);
                newShare.quantity = 0;
                newShare.selectedSchedule = undefined;
                newShares[key] = newShare;
            });
            let newOptions = {};
            Object.keys(newOptions).map((key) => {
                let newOption = Object.assign({},state.sharesData.options[key]);
                newOption.quantity = 0;
                newOption.selectedSchedule = undefined;
                newOptions[key] = newOption;
            });
            newState.sharesData = Object.assign({}, state.sharesData, {shares:newShares, options:newOptions});
            return newState;
        case SET_SELECTED_METHOD: {
            const selectedData = (state.selectedData || {});
            return Object.assign({}, state, {
                selectedData: Object.assign({}, selectedData, {selectedMethod: action.key})
            });
        }
        case SET_SIGNUP_COMMENTS: {
            const selectedData = (state.selectedData || {});
            return Object.assign({}, state, {
                selectedData: Object.assign({}, selectedData, {signupComments: action.comments})
            });
        }
        case SET_TERMS_SELECTED: {
            const selectedData = (state.selectedData || {});
            return Object.assign({}, state, {
                selectedData: Object.assign({}, selectedData, {termsSelected: action.isSelected})
            });
        }
        case SET_HOME_DELIVERY_INSTRUCTIONS: {
            const selectedData = (state.selectedData || {});
            return Object.assign({}, state, {
                selectedData: Object.assign({}, selectedData, {homeDeliveryInstructions: action.instructions})
            });
        }
        case SET_MAP_PROPS:
            let obj = Object.assign({}, state, {});
            if(action.centerLocation) {
                obj['centerLocation'] = action.centerLocation;
            }
            if(action.zoomLevel) {
                obj['zoomLevel'] = action.zoomLevel;
            }
            return obj;
        case INIT_MAP_PROPS:
            return Object.assign({}, state, {
                zoomLevel: undefined,
                centerLocation: undefined
            });
        case SET_INVALID_OPTION_SCHEDULE_MESSAGE:
            return Object.assign({}, state, {
                invalidOptionScheduleMessage: action.invalidOptionScheduleMessage
            });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/join/joinReducer.js